/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DwgIcon = createIcon("DwgIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#F1D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.262 33.333 29.08 38h3.98l3.726-4.667h-8.522Z",
    fill: "url(#dwg-a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.002 33.333h-4.87V38h2.436l2.434-4.667Z",
    fill: "url(#dwg-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.523 32.167h-6.407l-.899 1.545L13.67 38h3.724l1.086-4.046.043-.159v-1.628Z",
    fill: "url(#dwg-c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.652 34.5H10l3.268 3.49h.384V34.5Z",
    fill: "#561210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.652 34.5v-4.674l-3.25 2.669L10 34.5h3.652Z",
    fill: "#1F0F10"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.133 25.765 24.474 10 13.652 29.833l19.48-4.068Z",
    fill: "url(#dwg-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.652 29.827 17.97-6.877 2.728 10.383H13.652v-3.506Z",
    fill: "url(#dwg-e)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m31.561 22.933 1.937 10.4h4.505l-2.128-9.044-4.314-1.356Z",
    fill: "#381413"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.543 27.643 7.484-2.766L24.174 10l-4.631 17.643Z",
    fill: "url(#dwg-f)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.03 24.735 1.25 8.614h-9.777l1.034-5.718 7.493-2.896Z",
    fill: "url(#dwg-g)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-a",
    x1: "29.872",
    y1: "36.619",
    x2: "30.937",
    y2: "34.406",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".184",
    stopColor: "#AF2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".408",
    stopColor: "#C32A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".561",
    stopColor: "#CA2D28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-b",
    x1: "35.568",
    y1: "33.333",
    x2: "35.568",
    y2: "38",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#A51F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-c",
    x1: "14.87",
    y1: "32.167",
    x2: "14.87",
    y2: "38",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".074",
    stopColor: "#B42626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".337",
    stopColor: "#B02525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".62",
    stopColor: "#A52222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".912",
    stopColor: "#931C1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8C191C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-d",
    x1: "23.392",
    y1: "25.318",
    x2: "23.392",
    y2: "12.529",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".045",
    stopColor: "#84171A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".263",
    stopColor: "#9D2021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".477",
    stopColor: "#AF2524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".684",
    stopColor: "#BA2826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".877",
    stopColor: "#BE2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#AB1F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-e",
    x1: "13.652",
    y1: "28.142",
    x2: "34.35",
    y2: "28.142",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".312",
    stopColor: "#471514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#421313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-f",
    x1: "23.285",
    y1: "10",
    x2: "23.285",
    y2: "27.643",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE462F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".447",
    stopColor: "#D8412D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".927",
    stopColor: "#CA3228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#C72F28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwg-g",
    x1: "23.391",
    y1: "33.349",
    x2: "23.391",
    y2: "24.735",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#771315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".065",
    stopColor: "#791416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".621",
    stopColor: "#87181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8C191C"
  }))));
}, {
  "i18nKey": "svg.DwgIcon"
});